import styled from "styled-components";

export const Styles = styled.div`
  &:has(input:placeholder-shown) {
    .ant-input-group-addon {
      display: none;
    }
  }
  div.ant-row.ant-form-item-row
    > div.ant-col.ant-form-item-control
    > div:nth-child(2)
    > div:nth-child(2) {
    height: 0 !important;
  }
`;
